import { render, staticRenderFns } from "./OverallSalesCard.vue?vue&type=template&id=cf895940&scoped=true"
import script from "./OverallSalesCard.vue?vue&type=script&lang=js"
export * from "./OverallSalesCard.vue?vue&type=script&lang=js"
import style0 from "./OverallSalesCard.vue?vue&type=style&index=0&id=cf895940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf895940",
  null
  
)

export default component.exports